import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "fa-ul" }

import SubSection from '../common/SubSection.vue';
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";


export default /*@__PURE__*/_defineComponent({
  __name: 'Assumptions',
  setup(__props) {

const { textArray } = useUIContent();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "General assumptions",
        showHelp: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textArray)('modelling.assumptions.general.description'), (assumption, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(assumption), 1))
            }), 128))
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "alert alert-primary",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "bi bi-check-circle-fill" }),
            _createTextVNode(" It is very important to understand that in reality actual experience will always differ from these assumptions at least to some degree. The test page on the website is designed to allow you to consider various common scenarios which may occur which may affect your design. You should revisit your design each year to consider if it is still on course to provide what you want in retirement. ")
          ], -1))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})